import { useApiDocumentsV1DocumentsContextUrlRetrieve } from 'api';
import { dayjs } from 'date';
import { BackButton, Box, Link, Stack, Typography, TypographyIcon } from 'ui';
import { AccessTimeOutlined, CheckCircleOutlined } from 'ui/icons';

import { DOCUMENT_TYPE_DISPLAYED_VALUE } from '~/document/utils/document';
import { useDocument } from '~/document-generation/context/DocumentContext';

export const Header = () => {
  const { document } = useDocument();
  const { data: contextUrl } = useApiDocumentsV1DocumentsContextUrlRetrieve(document.id);

  const lastEditedAt = dayjs(document.updated_at).format('YYYY.MM.DD');

  return (
    <Box display="flex" alignItems="center" gap={1.5} marginBottom={1.25} mt={1.5} mx={3}>
      {window.history.length > 1 ? <BackButton onClick={() => window.history.back()} /> : null}
      <Stack useFlexGap direction="column" gap={1}>
        <Typography>
          <Typography fontWeight="bold" component="span">
            Review {DOCUMENT_TYPE_DISPLAYED_VALUE[document.document_type]} for
            {contextUrl?.url ? (
              <Link href={contextUrl.url}>
                {' '}
                {document.context_model_name} #{document.context_object_id}
              </Link>
            ) : (
              <Typography>
                {document.context_model_name} #{document.context_object_id}
              </Typography>
            )}
          </Typography>
        </Typography>
        <Box display="flex" gap={1.5} alignItems="center">
          <Typography fontSize={12} sx={(theme) => ({ color: theme.palette.grey[700] })}>
            Document last edited on {lastEditedAt}
          </Typography>
          {document.fully_signed ? (
            <Box display="flex" alignItems="center" gap={1}>
              <TypographyIcon
                fontSize={12}
                sx={(theme) => ({ color: theme.palette.grey[700] })}
                icon={() => <CheckCircleOutlined color="success" />}
              >
                Document signed
              </TypographyIcon>
            </Box>
          ) : (
            <Box display="flex" alignItems="center" gap={1}>
              <TypographyIcon
                fontSize={12}
                sx={(theme) => ({ color: theme.palette.grey[700] })}
                icon={() => <AccessTimeOutlined sx={(theme) => ({ color: theme.palette.grey[700] })} />}
              >
                Signature pending
              </TypographyIcon>
            </Box>
          )}
          {document.last_sent_at ? (
            <Box display="flex" alignItems="center" gap={1}>
              <TypographyIcon
                fontSize={12}
                sx={(theme) => ({ color: theme.palette.grey[700] })}
                icon={() => <AccessTimeOutlined sx={(theme) => ({ color: theme.palette.grey[700] })} />}
              >
                Sent on {dayjs(document.last_sent_at).format('YYYY.MM.DD HH:mm')}
              </TypographyIcon>
            </Box>
          ) : null}
        </Box>
      </Stack>
    </Box>
  );
};
